import React, {Component} from 'react';
import {Header} from './Header';
import {Footer} from './Footer';
import {pressReleasesPageText as pressReleasesPageText_en} from "../libs/en/texts-press-releases-page-lib";
import {pressReleasesPageText as pressReleasesPageText_en_ca} from "../libs/en-ca/texts-press-releases-page-lib";
import {pressReleasesPageText as pressReleasesPageText_de} from "../libs/de/texts-press-releases-page-lib";
import {pressReleasesPageText as pressReleasesPageText_de_ch} from "../libs/de-ch/texts-press-releases-page-lib";
import {pressReleasesPageText as pressReleasesPageText_fr} from "../libs/fr/texts-press-releases-page-lib";
import {pressReleasesPageText as pressReleasesPageText_fr_fr} from "../libs/fr-fr/texts-press-releases-page-lib";
import {pressReleasesPageText as pressReleasesPageText_fr_ca} from "../libs/fr-ca/texts-press-releases-page-lib";
import {pressReleasesPageText as pressReleasesPageText_nl} from "../libs/nl/texts-press-releases-page-lib";
import {pressReleasesPageText as pressReleasesPageText_it} from "../libs/it/texts-press-releases-page-lib";
import {pressReleasesPageText as pressReleasesPageText_it_ch} from "../libs/it-ch/texts-press-releases-page-lib";
import {pressReleasesPageText as pressReleasesPageText_cz} from "../libs/cz/texts-press-releases-page-lib";
import {pressReleasesPageText as pressReleasesPageText_fi} from "../libs/fi/texts-press-releases-page-lib";
import {pressReleasesPageText as pressReleasesPageText_pl} from "../libs/pl/texts-press-releases-page-lib";
import {pressReleasesPageText as pressReleasesPageText_se} from "../libs/se/texts-press-releases-page-lib";
import {pressReleasesPageText as pressReleasesPageText_no} from "../libs/no/texts-press-releases-page-lib";
import {pressReleasesPageText as pressReleasesPageText_dk} from "../libs/dk/texts-press-releases-page-lib";
import {pressReleasesPageText as pressReleasesPageText_es} from "../libs/es/texts-press-releases-page-lib";
import {pressReleasesPageText as pressReleasesPageText_pt} from "../libs/pt/texts-press-releases-page-lib";
import {homePageText as homePageText_en} from "../libs/en/texts-home-page-lib";
import {homePageText as homePageText_en_ca} from "../libs/en-ca/texts-home-page-lib";
import {homePageText as homePageText_de} from "../libs/de/texts-home-page-lib";
import {homePageText as homePageText_de_ch} from "../libs/de-ch/texts-home-page-lib";
import {homePageText as homePageText_fr} from "../libs/fr/texts-home-page-lib";
import {homePageText as homePageText_fr_ca} from "../libs/fr-ca/texts-home-page-lib";
import {homePageText as homePageText_nl} from "../libs/nl/texts-home-page-lib";
import {homePageText as homePageText_it} from "../libs/it/texts-home-page-lib";
import {homePageText as homePageText_it_ch} from "../libs/it-ch/texts-home-page-lib";
import {homePageText as homePageText_cz} from "../libs/cz/texts-home-page-lib";
import {homePageText as homePageText_fi} from "../libs/fi/texts-home-page-lib";
import {homePageText as homePageText_pl} from "../libs/pl/texts-home-page-lib";
import {homePageText as homePageText_se} from "../libs/se/texts-home-page-lib";
import {homePageText as homePageText_no} from "../libs/no/texts-home-page-lib";
import {homePageText as homePageText_dk} from "../libs/dk/texts-home-page-lib";
import {homePageText as homePageText_es} from "../libs/es/texts-home-page-lib";
import {homePageText as homePageText_pt} from "../libs/pt/texts-home-page-lib";
import parse from "html-react-parser";
import {Helmet} from 'react-helmet';
import {Link} from "react-router-dom";
import fileIcon from '../assets/images/doc-icon.svg';

export class PressReleases extends Component {

    constructor(props) {
        super(props);
        this.state = {
            language: this.props.language,
            pressReleasesPageText: pressReleasesPageText_en,
            homePageText: homePageText_en,
            prefix: '',
            visibleCount: 5, // Number of items to show initially
            initialCount: 5, // Store initial count for "Show less" functionality
        };
        this.handleShowMore = this.handleShowMore.bind(this);
        this.handleShowLess = this.handleShowLess.bind(this);
        if (this.state.language === "DE") {
            this.state.pressReleasesPageText = pressReleasesPageText_de;
            this.state.homePageText = homePageText_de;
            this.state.prefix = '/de';
        }
        if (this.state.language === "DE-CH") {
            this.state.pressReleasesPageText = pressReleasesPageText_de_ch;
            this.state.homePageText = homePageText_de_ch;
            this.state.prefix = '/de-ch';
        }
        if (this.state.language === "EN-CA") {
            this.state.pressReleasesPageText = pressReleasesPageText_en_ca;
            this.state.homePageText = homePageText_en_ca;
            this.state.prefix = '/en-ca';
        }
        if (this.state.language === "FR-FR") {
            this.state.pressReleasesPageText = pressReleasesPageText_fr_fr;
            this.state.homePageText = homePageText_fr; // Use fr homePageText for fr-fr
            this.state.prefix = '/fr';
        }
        if (this.state.language === "FR") {
            this.state.pressReleasesPageText = pressReleasesPageText_fr;
            this.state.homePageText = homePageText_fr;
            this.state.prefix = '/fr-ch';
        }
        if (this.state.language === "FR-CA") {
            this.state.pressReleasesPageText = pressReleasesPageText_fr_ca;
            this.state.homePageText = homePageText_fr_ca;
            this.state.prefix = '/fr-ca';
        }
        if (this.state.language === "NL") {
            this.state.pressReleasesPageText = pressReleasesPageText_nl;
            this.state.homePageText = homePageText_nl;
            this.state.prefix = '/nl';
        }
        if (this.state.language === "IT") {
            this.state.pressReleasesPageText = pressReleasesPageText_it;
            this.state.homePageText = homePageText_it;
            this.state.prefix = '/it';
        }
        if (this.state.language === "IT-CH") {
            this.state.pressReleasesPageText = pressReleasesPageText_it_ch;
            this.state.homePageText = homePageText_it_ch;
            this.state.prefix = '/it-ch';
        }
        if (this.state.language === "CZ") {
            this.state.pressReleasesPageText = pressReleasesPageText_cz;
            this.state.homePageText = homePageText_cz;
            this.state.prefix = '/cz';
        }
        if (this.state.language === "FI") {
            this.state.pressReleasesPageText = pressReleasesPageText_fi;
            this.state.homePageText = homePageText_fi;
            this.state.prefix = '/fi';
        }
        if (this.state.language === "PL") {
            this.state.pressReleasesPageText = pressReleasesPageText_pl;
            this.state.homePageText = homePageText_pl;
            this.state.prefix = '/pl';
        }
        if (this.state.language === "SE") {
            this.state.pressReleasesPageText = pressReleasesPageText_se;
            this.state.homePageText = homePageText_se;
            this.state.prefix = '/se';
        }
        if (this.state.language === "NO") {
            this.state.pressReleasesPageText = pressReleasesPageText_no;
            this.state.homePageText = homePageText_no;
            this.state.prefix = '/nb';
        }
        if (this.state.language === "DK") {
            this.state.pressReleasesPageText = pressReleasesPageText_dk;
            this.state.homePageText = homePageText_dk;
            this.state.prefix = '/dk';
        }
        if (this.state.language === "ES") {
            this.state.pressReleasesPageText = pressReleasesPageText_es;
            this.state.homePageText = homePageText_es;
            this.state.prefix = '/es';
        }
        if (this.state.language === "PT") {
            this.state.pressReleasesPageText = pressReleasesPageText_pt;
            this.state.homePageText = homePageText_pt;
            this.state.prefix = '/pt';
        }
    }

    setLanguageVars() {
        if (this.state.language !== this.props.language) {
            if (this.props.language === "EN") {
                this.setState({
                    language: this.props.language,
                    pressReleasesPageText: pressReleasesPageText_en,
                    homePageText: homePageText_en,
                    prefix: '',
                });
            }
            if (this.props.language === "DE") {
                this.setState({
                    language: this.props.language,
                    pressReleasesPageText: pressReleasesPageText_de,
                    homePageText: homePageText_de,
                    prefix: '/de',
                });
            }
            if (this.props.language === "DE-CH") {
                this.setState({
                    language: this.props.language,
                    pressReleasesPageText: pressReleasesPageText_de_ch,
                    homePageText: homePageText_de_ch,
                    prefix: '/de-ch',
                });
            }
            if (this.props.language === "EN-CA") {
                this.setState({
                    language: this.props.language,
                    pressReleasesPageText: pressReleasesPageText_en_ca,
                    homePageText: homePageText_en_ca,
                    prefix: '/en-ca',
                });
            }
            if (this.props.language === "FR-FR") {
                this.setState({
                    language: this.props.language,
                    pressReleasesPageText: pressReleasesPageText_fr_fr,
                    homePageText: homePageText_fr, // Use fr homePageText for fr-fr
                    prefix: '/fr',
                });
            }
            if (this.props.language === "FR") {
                this.setState({
                    language: this.props.language,
                    pressReleasesPageText: pressReleasesPageText_fr,
                    homePageText: homePageText_fr,
                    prefix: '/fr-ch',
                });
            }
            if (this.props.language === "FR-CA") {
                this.setState({
                    language: this.props.language,
                    pressReleasesPageText: pressReleasesPageText_fr_ca,
                    homePageText: homePageText_fr_ca,
                    prefix: '/fr-ca',
                });
            }
            if (this.props.language === "NL") {
                this.setState({
                    language: this.props.language,
                    pressReleasesPageText: pressReleasesPageText_nl,
                    homePageText: homePageText_nl,
                    prefix: '/nl',
                });
            }
            if (this.props.language === "IT") {
                this.setState({
                    language: this.props.language,
                    pressReleasesPageText: pressReleasesPageText_it,
                    homePageText: homePageText_it,
                    prefix: '/it',
                });
            }
            if (this.props.language === "IT-CH") {
                this.setState({
                    language: this.props.language,
                    pressReleasesPageText: pressReleasesPageText_it_ch,
                    homePageText: homePageText_it_ch,
                    prefix: '/it-ch',
                });
            }
            if (this.props.language === "CZ") {
                this.setState({
                    language: this.props.language,
                    pressReleasesPageText: pressReleasesPageText_cz,
                    homePageText: homePageText_cz,
                    prefix: '/cz',
                });
            }
            if (this.props.language === "FI") {
                this.setState({
                    language: this.props.language,
                    pressReleasesPageText: pressReleasesPageText_fi,
                    homePageText: homePageText_fi,
                    prefix: '/fi',
                });
            }
            if (this.props.language === "PL") {
                this.setState({
                    language: this.props.language,
                    pressReleasesPageText: pressReleasesPageText_pl,
                    homePageText: homePageText_pl,
                    prefix: '/pl',
                });
            }
            if (this.props.language === "SE") {
                this.setState({
                    language: this.props.language,
                    pressReleasesPageText: pressReleasesPageText_se,
                    homePageText: homePageText_se,
                    prefix: '/se',
                });
            }
            if (this.props.language === "NO") {
                this.setState({
                    language: this.props.language,
                    pressReleasesPageText: pressReleasesPageText_no,
                    homePageText: homePageText_no,
                    prefix: '/nb',
                });
            }
            if (this.props.language === "DK") {
                this.setState({
                    language: this.props.language,
                    pressReleasesPageText: pressReleasesPageText_dk,
                    homePageText: homePageText_dk,
                    prefix: '/dk',
                });
            }
            if (this.props.language === "ES") {
                this.setState({
                    language: this.props.language,
                    pressReleasesPageText: pressReleasesPageText_es,
                    homePageText: homePageText_es,
                    prefix: '/es',
                });
            }
            if (this.props.language === "PT") {
                this.setState({
                    language: this.props.language,
                    pressReleasesPageText: pressReleasesPageText_pt,
                    homePageText: homePageText_pt,
                    prefix: '/pt',
                });
            }
        }
    }

    componentDidMount() {
        this.setLanguageVars();
    }

    componentDidUpdate() {
        this.setLanguageVars();
    }

    handleShowMore() {
        this.setState(prevState => ({
            visibleCount: prevState.visibleCount + 5
        }));
    }

    handleShowLess() {
        this.setState({
            visibleCount: this.state.initialCount
        });
        // Scroll to the top of the press releases section
        const section = document.querySelector('.press-releases-list');
        if (section) {
            section.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
    }

    formatDateToUppercase(dateString) {
        // Convert date from "22 March 2022" to "22 MARCH 2022"
        if (!dateString) return '';
        return dateString.toUpperCase();
    }

    getPressReleases() {
        // Press releases are always in English
        const homeText = homePageText_en;
        
        // Press releases from home page data, ordered by date (newest first)
        const releases = [];

        // CamAPS Liberty launch (1 Sep 2026)
        if (homeText.dateLibertyLaunchPressRelease && homeText.headingLibertyLaunchPressRelease) {
            releases.push({
                id: releases.length + 1,
                slug: 'liberty-launch',
                date: this.formatDateToUppercase(homeText.dateLibertyLaunchPressRelease),
                title: parse(homeText.headingLibertyLaunchPressRelease),
                description: parse(homeText.textLibertyLaunchPressRelease),
                downloadUrl: 'https://s3.eu-west-1.amazonaws.com/admin.camdiab.com/press.release/camaps_liberty_launch-pr.pdf',
                fileName: 'camaps_liberty_launch-pr.pdf',
                downloadDisabled: true
            });
        }

        // NPID HCL analysis in pregnancy (20 Jul 2026)
        if (homeText.dateNpidHcl260720PressRelease && homeText.headingNpidHcl260720PressRelease) {
            releases.push({
                id: releases.length + 1,
                slug: 'npid-hcl-pregnancy',
                date: this.formatDateToUppercase(homeText.dateNpidHcl260720PressRelease),
                title: parse(homeText.headingNpidHcl260720PressRelease),
                description: parse(homeText.textNpidHcl260720PressRelease),
                downloadUrl: 'https://s3.eu-west-1.amazonaws.com/admin.camdiab.com/press.release/npid_hcl_Analysis_260720.pdf',
                fileName: 'npid_hcl_Analysis_260720.pdf'
            });
        }

        // Dexcom G7 and CamAPS FX integration (3 Jun 2026)
        if (homeText.dateDexcomG7PressRelease && homeText.headingDexcomG7PressRelease) {
            releases.push({
                id: releases.length + 1,
                slug: 'dexcom-g7',
                date: this.formatDateToUppercase(homeText.dateDexcomG7PressRelease),
                title: parse(homeText.headingDexcomG7PressRelease),
                description: parse(homeText.textDexcomG7PressRelease),
                downloadUrl: 'https://s3.eu-west-1.amazonaws.com/admin.camdiab.com/press.release/mylife_CamDiab_Dexcom_G7_launch_release_260603.pdf',
                fileName: 'mylife_CamDiab_Dexcom_G7_launch_release_260603.pdf'
            });
        }
        
        // CamAPS Liberty Press Release (10 Mar 2026)
        if (homeText.dateLiberty260310PressRelease && homeText.headingLiberty260310PressRelease) {
            releases.push({
                id: releases.length + 1,
                slug: 'liberty-260310',
                date: this.formatDateToUppercase(homeText.dateLiberty260310PressRelease),
                title: parse(homeText.headingLiberty260310PressRelease),
                description: parse(homeText.textLiberty260310PressRelease),
                downloadUrl: 'https://s3.eu-west-1.amazonaws.com/admin.camdiab.com/press.release/PRESS%20RELEASE%20CamAPS%20Liberty_260310.pdf',
                fileName: 'PRESS RELEASE CamAPS Liberty_260310.pdf'
            });
        }
        
        // Canada iOS Press Release (15 Jan 2026)
        if (homeText.dateCanadaIOSPressRelease && homeText.headingCanadaIOSPressRelease) {
            releases.push({
                id: releases.length + 1,
                slug: 'canada-ios',
                date: this.formatDateToUppercase(homeText.dateCanadaIOSPressRelease),
                title: parse(homeText.headingCanadaIOSPressRelease),
                description: parse(homeText.textCanadaIOSPressRelease),
                downloadUrl: 'https://s3.eu-west-1.amazonaws.com/admin.camdiab.com/press.release/Press-release_Canada_iOS_FSL3.pdf',
                fileName: 'Press-release_Canada_iOS_FSL3.pdf'
            });
        }
        
        // Liberty EU MDR / Fully closed-loop (8 Jan 2026)
        if (homeText.dateInitialLibertyIOSPressRelease && homeText.headingInitialLibertyIOSPressRelease) {
            releases.push({
                id: releases.length + 1,
                slug: 'liberty-eu-mdr',
                date: this.formatDateToUppercase(homeText.dateInitialLibertyIOSPressRelease),
                title: parse(homeText.headingInitialLibertyIOSPressRelease),
                description: parse(homeText.textInitialLibertyIOSPressRelease),
                downloadUrl: 'https://s3.eu-west-1.amazonaws.com/admin.camdiab.com/press.release/press-release-fully-closed-loop-approval-20260108.pdf',
                fileName: 'press-release-fully-closed-loop-approval-20260108.pdf'
            });
        }
        
        // Companion iOS Press Release (23 Sep 2025)
        if (homeText.dateCompanionIOSPressRelease && homeText.headingCompanionIOSPressRelease) {
            releases.push({
                id: releases.length + 1,
                slug: 'companion-ios',
                date: this.formatDateToUppercase(homeText.dateCompanionIOSPressRelease),
                title: parse(homeText.headingCompanionIOSPressRelease),
                description: parse(homeText.textCompanionIOSPressRelease),
                downloadUrl: 'https://s3.eu-west-1.amazonaws.com/admin.camdiab.com/press.release/PRESS_RELEASE_CamDiab_Announce_iPhone_Companion.pdf',
                fileName: 'PRESS_RELEASE_CamDiab_Announce_iPhone_Companion.pdf'
            });
        }
        
        // iOS Wave 2 Press Release (10 Jun 2025)
        if (homeText.dateIOSPressReleaseWave2 && homeText.headingIOSPressReleaseWave2) {
            releases.push({
                id: releases.length + 1,
                slug: 'ios-wave2',
                date: this.formatDateToUppercase(homeText.dateIOSPressReleaseWave2),
                title: parse(homeText.headingIOSPressReleaseWave2),
                description: parse(homeText.textIOSPressReleaseWave2),
                downloadUrl: 'https://s3.eu-west-1.amazonaws.com/admin.camdiab.com/press.release/250610__Ypsomed_Press_Release_iOS_wave2_final.pdf',
                fileName: '250610__Ypsomed_Press_Release_iOS_wave2_final.pdf'
            });
        }
        
        // iOS UK Press Release (20 May 2025)
        if (homeText.dateIOSPressReleaseUK && homeText.headingIOSPressReleaseUK) {
            releases.push({
                id: releases.length + 1,
                slug: 'ios-uk',
                date: this.formatDateToUppercase(homeText.dateIOSPressReleaseUK),
                title: parse(homeText.headingIOSPressReleaseUK),
                description: parse(homeText.textIOSPressReleaseUK),
                downloadUrl: 'https://s3.eu-west-1.amazonaws.com/admin.camdiab.com/press.release/CamAPS_FX_iOS_press_release_UK.pdf',
                fileName: 'CamAPS_FX_iOS_press_release_UK.pdf'
            });
        }
        
        // iOS Press Release (18 Mar 2025)
        if (homeText.dateIOSPressRelease && homeText.headingIOSPressRelease) {
            releases.push({
                id: releases.length + 1,
                slug: 'ios',
                date: this.formatDateToUppercase(homeText.dateIOSPressRelease),
                title: parse(homeText.headingIOSPressRelease),
                description: parse(homeText.textIOSPressRelease),
                downloadUrl: 'https://s3.eu-west-1.amazonaws.com/admin.camdiab.com/press.release/CamAPS_FX_iOS_press_release.pdf',
                fileName: 'CamAPS_FX_iOS_press_release.pdf'
            });
        }
        
        // FDA Press Release (24 May 2024)
        if (homeText.dateFDAPressRelease && homeText.headingFDAPressRelease) {
            releases.push({
                id: releases.length + 1,
                slug: 'fda',
                date: this.formatDateToUppercase(homeText.dateFDAPressRelease),
                title: parse(homeText.headingFDAPressRelease),
                description: parse(homeText.textFDAPressRelease),
                downloadUrl: 'https://s3.eu-west-1.amazonaws.com/admin.camdiab.com/press.release/CamDiab+secures+FDA+approval+for+advanced+adaptive+hybrid+closed-loop+app+CamAPS+FX.pdf',
                fileName: 'CamDiab+secures+FDA+approval+for+advanced+adaptive+hybrid+closed-loop+app+CamAPS+FX.pdf'
            });
        }
        
        // Libre Press Release (25 Nov 2022)
        if (homeText.dateLibrePressRelease && homeText.headingLibrePressRelease) {
            releases.push({
                id: releases.length + 1,
                slug: 'libre',
                date: this.formatDateToUppercase(homeText.dateLibrePressRelease),
                title: parse(homeText.headingLibrePressRelease),
                description: parse(homeText.textLibrePressRelease),
                downloadUrl: 'https://s3.eu-west-1.amazonaws.com/admin.camdiab.com/press.release/221125_Ypsomed_PressRelease_FreeStyle_Libre3_final%20(003).pdf',
                fileName: '221125_Ypsomed_PressRelease_FreeStyle_Libre3_final%20(003).pdf'
            });
        }
        
        // ADC Press Release (27 Apr 2022)
        if (homeText.dateAdcPressRelease && homeText.headingAdcPressRelease) {
            releases.push({
                id: releases.length + 1,
                slug: 'adc',
                date: this.formatDateToUppercase(homeText.dateAdcPressRelease),
                title: parse(homeText.headingAdcPressRelease),
                description: parse(homeText.textAdcPressRelease),
                downloadUrl: 'https://s3.eu-west-1.amazonaws.com/admin.camdiab.com/press.release/ADC_CamDiab_Ypsomed_Joint_Press_Release_4.24.22.pdf',
                fileName: 'ADC_CamDiab_Ypsomed_Joint_Press_Release_4.24.22.pdf'
            });
        }
        
        // Ypso Press Release (22 Mar 2022)
        if (homeText.dateYpsoPressRelease && homeText.headingYpsoPressRelease) {
            releases.push({
                id: releases.length + 1,
                slug: 'ypso',
                date: this.formatDateToUppercase(homeText.dateYpsoPressRelease),
                title: parse(homeText.headingYpsoPressRelease),
                description: parse(homeText.textYpsoPressRelease),
                downloadUrl: 'https://s3.eu-west-1.amazonaws.com/admin.camdiab.com/press.release/220322_Media_release_EN_final+Ypsomed.pdf',
                fileName: '220322_Media_release_EN_final+Ypsomed.pdf'
            });
        }
        // CE marking and UK launch (20 Mar 2020)
        if (homeText.dateCELaunchPressRelease && homeText.headingCELaunchPressRelease) {
            releases.push({
                id: releases.length + 1,
                slug: 'ce-launch',
                date: this.formatDateToUppercase(homeText.dateCELaunchPressRelease),
                title: parse(homeText.headingCELaunchPressRelease),
                description: parse(homeText.textCELaunchPressRelease),
                downloadUrl: 'https://s3.eu-west-1.amazonaws.com/admin.camdiab.com/press.release/Press+release+-+launch+16+March+2020.pdf',
                fileName: 'Press+release+-+launch+16+March+2020.pdf'
            });
        }
        
        return releases;
    }

    render() {
        const pressReleases = this.getPressReleases();
        const visibleReleases = pressReleases.slice(0, this.state.visibleCount);
        const hasMore = this.state.visibleCount < pressReleases.length;
        const showingMore = this.state.visibleCount > this.state.initialCount;
        // Show only one button: "Show more" when there are more items to load,
        // "Show less" only when all items are visible (so they never appear together)
        const showMoreButton = hasMore;
        const showLessButton = showingMore && !hasMore;
        return (
            <div className="press-releases-page">
                <Helmet>
                    <title>{parse(this.state.pressReleasesPageText.title)}</title>
                    <meta name="title" content={parse(this.state.pressReleasesPageText.titleMeta)}/>
                    <meta name="description" content={parse(this.state.pressReleasesPageText.descriptionMeta)}/>
                    <meta name="keywords" content={this.state.pressReleasesPageText.keywords}/>
                    <meta charSet="utf-8"/>
                    <meta property="og:locale" content={this.state.pressReleasesPageText.localeMeta}/>
                </Helmet>
                <Header props={this.props}/>
                
                {/* Banner Section */}
                <section className="press-releases-banner">
                    <div className="container">
                        <div className="row justify-content-center">
                            <div className="col-12 press-releases-banner-content">
                                <h1 className="press-releases-banner-title">{parse(this.state.pressReleasesPageText.bannerTitle)}</h1>
                                {this.state.pressReleasesPageText.bannerSubtitle && (
                                    <p className="press-releases-banner-subtitle">{parse(this.state.pressReleasesPageText.bannerSubtitle)}</p>
                                )}
                            </div>
                        </div>
                    </div>
                </section>

                {/* Press Contact Section */}
                <section className="press-contact-section">
                    <div className="container">
                        <div className="row justify-content-center">
                            <div className="col-12">
                                <p className="press-contact-text">
                                    {parse(this.state.pressReleasesPageText.contactText)}
                                </p>
                                {this.state.pressReleasesPageText.pressReleasesDisclaimer && (
                                    <p className="press-releases-disclaimer">{this.state.pressReleasesPageText.pressReleasesDisclaimer}</p>
                                )}
                            </div>
                        </div>
                    </div>
                </section>

                {/* Press Releases List Section */}
                <section className="press-releases-list">
                    <div className="container">
                        <div className="row justify-content-center">
                            <div className="col-12 press-releases-list-content">
                                {visibleReleases.map((release) => (
                                    <div key={release.id} className="press-release-item">
                                        <div className="press-release-icon">
                                            <img src={fileIcon} alt="Document" />
                                        </div>
                                        <div className="press-release-content">
                                            <div className="press-release-date">{release.date}</div>
                                            <Link to={"/press-releases/" + release.slug} className="press-release-title-link">
                                                <h3 className="press-release-title">{release.title}</h3>
                                            </Link>
                                            <p className="press-release-description">{release.description}</p>
                                            {release.downloadDisabled ? (
                                            <span
                                                className="press-release-download is-disabled"
                                                aria-disabled="true"
                                            >
                                                <svg width="15" height="19" viewBox="0 0 15 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path fill-rule="evenodd" clip-rule="evenodd" d="M13.4321 6.25919L8.61965 10.8987V0H6.38027V10.8987L1.56778 6.25919L0 7.76961L7.5 15L15 7.76961L13.4321 6.25919Z" fill="#02ACA0"/>
                                                <path fill-rule="evenodd" clip-rule="evenodd" d="M1 17H14V19H1V17Z" fill="#02ACA0"/>
                                                </svg>

                                                {parse(pressReleasesPageText_en.download)}
                                            </span>
                                            ) : (
                                            <a 
                                                href={release.downloadUrl} 
                                                className="press-release-download"
                                                download={release.fileName}
                                                target="_blank"
                                                rel="noopener noreferrer"
                                            >
                                                <svg width="15" height="19" viewBox="0 0 15 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path fill-rule="evenodd" clip-rule="evenodd" d="M13.4321 6.25919L8.61965 10.8987V0H6.38027V10.8987L1.56778 6.25919L0 7.76961L7.5 15L15 7.76961L13.4321 6.25919Z" fill="#02ACA0"/>
                                                <path fill-rule="evenodd" clip-rule="evenodd" d="M1 17H14V19H1V17Z" fill="#02ACA0"/>
                                                </svg>

                                                {parse(pressReleasesPageText_en.download)}
                                            </a>
                                            )}
                                        </div>
                                    </div>
                                ))}
                                
                                {showMoreButton && (
                                    <div className="press-releases-show-more">
                                        <button onClick={this.handleShowMore} className="press-releases-show-more-button">
                                            <span>{parse(this.state.pressReleasesPageText.showMore)}</span>
                                            <svg width="12" height="8" viewBox="0 0 12 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M1 1L6 6L11 1" stroke="#04ABA0" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                                            </svg>
                                        </button>
                                    </div>
                                )}
                                
                                {showLessButton && (
                                    <div className="press-releases-show-less">
                                        <button onClick={this.handleShowLess} className="press-releases-show-less-button">
                                            <span>{parse(this.state.pressReleasesPageText.showLess)}</span>
                                            <svg width="12" height="8" viewBox="0 0 12 8" fill="none" xmlns="http://www.w3.org/2000/svg" style={{transform: 'rotate(180deg)'}}>
                                                <path d="M1 1L6 6L11 1" stroke="#04ABA0" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                                            </svg>
                                        </button>
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                </section>

                <Footer props={this.props}/>
            </div>
        );
    }
}

